const colors = {
  cream: '#F8CB5F',
  torea: '#132790',
  valencia: '#DA443A',
  casper: '#AFC7D2',
  deepCove: '#08103A',
}

export default colors
